// extracted by mini-css-extract-plugin
module.exports = {"quickButton":"QuickAccessButton_quickButton__3_nCa","button":"QuickAccessButton_button__CE7L3"};